<template>
  <div class="sidebar-container">
    <div class="greeting">
      <img
        @click="logoClick"
        src="@/assets/icons/cool.svg"
        alt="welcome picture"
      />
      <span class="welcome-message" v-if="!user"
        >Hello there, please log in
      </span>
      <span class="welcome-message" v-if="user">Welcome back Matt!</span>
      <div class="logout" @click="handleLogout" v-if="user">
        <img class="logout-img" src="@/assets/icons/logout.svg" alt="" />
      </div>
    </div>
    <div class="links" v-if="user">
      <ul>
        <li>
          <router-link to="/messages" active-class="active-link">
            <img
              src="@/assets/icons/email.svg"
              alt="messages icon"
              class="icon"
            />
            Messages
          </router-link>
        </li>
        <li>
          <router-link to="/projects" active-class="active-link">
            <img
              src="@/assets/icons/dashboard.svg"
              alt="dashboard icon"
              class="icon"
            />
            Projects
          </router-link>
        </li>
        <li>
          <router-link to="/create" active-class="active-link">
            <img src="@/assets/icons/plus.svg" alt="plus icon" class="icon" />
            Create Project
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import getUser from '@/composables/getUser';
import useLogout from '@/composables/useLogout';
import router from '@/router';
export default {
  setup() {
    const { user } = getUser();
    const { logout } = useLogout();

    const handleLogout = async () => {
      await logout();
      router.push('/login');
    };

    const logoClick = () => {
      router.push('/');
    };

    return {
      handleLogout,
      user,
      logoClick,
    };
  },
};
</script>

<style scoped>
.sidebar-container {
  width: 300px;
  height: 100vh;
  background-color: white;
  border-right: 1px solid black;
  color: black;
}

.greeting {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding: 40px 30px;
  border-bottom: 1px solid black;
}

img {
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.logout-img {
  width: 25px;
  height: 25px;
  border-radius: 0px;
  cursor: pointer;
}

.welcome-message {
  font-size: 20px;

  margin-top: 10px;
  margin-bottom: 10px;
}
.links li {
  margin-top: 10px;
}
.links a {
  display: flex;
  align-items: center;
  padding: 10px;
  padding-left: 20px;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
}
.links a img {
  width: 25px;
  height: 25px;
  margin-right: 20px;
  filter: brightness(0) saturate(100%);
}

.links a.active-link {
  background-color: black;
  border-radius: 20px 0 0 20px;
  color: white;
}
.links a.active-link img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%)
    hue-rotate(0deg) brightness(100%) contrast(100%);
}

.logout {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
  color: var(--text);
}
.logout-text {
  cursor: pointer;
}
.material-symbols-outlined {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
</style>
